import * as Yup from "yup";
import moment from "moment";
// eslint-disable-next-line import/no-unresolved
import { AssignmentDetails } from "../ProposalDetails/interfaces";
import regex from "../../regex";

const initialValues: AssignmentDetails = {
  assignor: "",
  assignorJoint: "",
  assignorName: "",
  assigmentAt: "",
  signedDate: "",
  place: "",
  placeCode: "",
  reasonForAssigment: "",
  witnessName: "",
  address: "",
  pincode: "",
  occupation: "",
  occupationCode: ""
};

const validationSchema = (assignmentMefFields: any) =>
  Yup.object().shape<Record<keyof AssignmentDetails, Yup.AnySchema>>({
    assignor: Yup.string()
      .min(1, "Min 1 character allowed")
      .max(60, "Max 60 characters allowed")
      .when([], (_, schema) =>
        assignmentMefFields?.assignor?.required ? schema.required("Assignor is required") : schema
      ),

    assignorJoint: Yup.string()
      .min(1, "Min 1 character allowed")
      .max(60, "Max 60 characters allowed")
      .when([], (_, schema) =>
        assignmentMefFields?.assignorJoint?.required
          ? schema.required("Assignor Joint is required")
          : schema
      ),

    assignorName: Yup.string()
      .min(1, "Min 1 character allowed")
      .max(75, "Max 75 characters allowed")
      .when([], (_, schema) =>
        assignmentMefFields?.assignorName?.required
          ? schema.required("Assignor Name is required")
          : schema
      ),

    assigmentAt: Yup.string()
      .matches(regex.address1, "Enter valid value")
      .min(1, "Min 1 Characters Allowed")
      .max(50, "Max 50 Chars Allowed")
      .when([], (_, schema) =>
        assignmentMefFields?.assigmentAt?.required
          ? schema.required("Assignment At is required")
          : schema
      ),

    signedDate: Yup.string()
      .when([], (_, schema) => {
        const baseSchema = schema
          .test("length", "Invalid date", (value) => !value || value?.length === 10)
          .test(
            "is-valid-date",
            "Invalid date",
            (value) => !value || moment(value.trim(), "DD/MM/YYYY", true).isValid()
          )
          .test("is-today-or-tomorrow", "Date must be today or tomorrow", (value) => {
            if (!value) return true;

            const trimmed = value.trim();
            const inputDate = moment(trimmed, "DD/MM/YYYY", true);
            const isValid = inputDate.isValid();
            const inputFormatted = inputDate.format("DD/MM/YYYY");

            const today = moment();
            const tomorrow = moment().add(1, "day");
            const todayStr = today.format("DD/MM/YYYY");
            const tomorrowStr = tomorrow.format("DD/MM/YYYY");

            if (!isValid) return false;

            return inputFormatted === todayStr || inputFormatted === tomorrowStr;
          });

        return assignmentMefFields?.signedDate?.required
          ? baseSchema.required("Signed Date is required")
          : baseSchema;
      })
      .default(""),
    place: Yup.string()
      .min(1, "Min 1 character allowed")
      .max(50, "Max 50 characters allowed")
      .when([], (_, schema) =>
        assignmentMefFields?.place?.required ? schema.required("Place is required") : schema
      ),

    reasonForAssigment: Yup.string()
      .matches(regex.alphaNumericWithoutConsecutiveSpace, "Enter valid value")
      .min(2, "Min 2 character allowed")
      .max(100, "Max 100 characters allowed")
      .when([], (_, schema) =>
        assignmentMefFields?.reasonForAssigment?.required
          ? schema.required("Reason for Assignment is required")
          : schema
      ),

    witnessName: Yup.string()
      .min(1, "Min 1 character allowed")
      .max(60, "Max 60 characters allowed")
      .matches(regex.alphabetWithFullStop, "Enter valid value")
      .when([], (_, schema) =>
        assignmentMefFields?.witnessName?.required
          ? schema.required("Witness Name is required")
          : schema
      ),

    address: Yup.string()
      .min(1, "Min 1 character allowed")
      .max(90, "Max 90 characters allowed")
      .when([], (_, schema) =>
        assignmentMefFields?.address?.required ? schema.required("Address is required") : schema
      ),

    pincode: Yup.string()
      .matches(regex.pincode, "Invalid Pincode")
      .when([], (_, schema) =>
        assignmentMefFields?.pincode?.required ? schema.required("Pincode is required") : schema
      ),

    occupation: Yup.string().when([], (_id, schema) =>
      assignmentMefFields?.occupation?.required
        ? schema.required("Occupation is required")
        : schema.notRequired()
    ),
    occupationCode: Yup.string(),
    placeCode: Yup.string()
  });

export { initialValues, validationSchema };
